<template>
  <v-scale-transition>
    <v-btn
      v-show="displayed"
      style="position:fixed"
      :style="{bottom: bottom, left:left}"
      :width="buttonSize"
      :height="buttonSize"
      :color="buttonColor"
      :fab="isFab"
      class="menuButton"
    >
      <v-icon
        :color="iconColor"
      >
        {{ icon }} {{ iconSize }}
      </v-icon>
    </v-btn>
  </v-scale-transition>
</template>
<script>

export default {
  name: 'MenuButton',
  props: {
    bottom: {
      type: String,
      default: '0px',
    },
    left: {
      type: String,
      default: '0px',
    },
    buttonSize: {
      type: String,
      default: '44px',
    },
    buttonColor: {
      type: String,
      default: '44px',
    },
    isFab: Boolean,
    displayed: Boolean,
    icon: {
      type: String,
      default: 'mdi-file-question-outline',
    },
    iconSize: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: true,
    };
  },
};
</script>
